/**
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

/**
 Used to customize scrollbars
 **/

define([
    "dojo/_base/declare",
    "dojo/sniff"
], function (declare, has) {

    return declare(null, {
        postCreate: function() {
            this.inherited(arguments);
            if(!has("mac")) {
                this.domNode.classList.add("mwScrollbarMixin");
            }
        }
    });
});
